<template>
  <KoreanPancakeBody />
</template>

<script>
import KoreanPancakeBody from '../molecules/KoreanPancakeBody.vue'


export default {
  name: 'KoreanPancakeView',
  components: {
    KoreanPancakeBody,
  }
}
</script>
